//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileIcon from "../../../assets/files.svg";
export default {
  data(){
    return{
      srcList: [
        this.message.fileUrl
      ]
    }
  },
  props: {
    icons: {
      type: Object,
      default: function () {
        return {
          file: {
            img: FileIcon,
            name: 'default'
          },
        }
      }
     },
    message: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
}
